<template>
  <div>
    <div class="bill-card__title">
      Pagamento concluído
    </div>

    <div class="bill-card__bill-status">
      <div class="bill-card__bill-status-title">
        Parabéns! Todas as mensalidades do {{ contract.period_name }} foram pagas
      </div>

      <img
        :src="require('assets/images/cobranca-finalizada.svg')"
        class="bill-card__bill-status-image"
      >
    </div>

    <router-link
      tag="button"
      :to="{ name: 'payments-history' }"
      class="z-button z-button--primary z-button--block"
    >
      Ver Detalhes
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
@import '@quero/zilla-core/src/atoms/z-caption';

.bill-card__title {
  @extend .z-caption;
  margin-bottom: var(--space-small);
  text-align: center;
}

.bill-card__bill-status {
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--space-medium);
  text-align: center;
}

.bill-card__bill-status-title {
  font-size: rem(19);
  line-height: rem(23);
  margin-bottom: var(--space-medium);
}

.bill-card__bill-status-image {
  height: 100px;
}
</style>

<script>
export default {
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
};
</script>
